<form [formGroup]="policyChangeRequestForm" (ngSubmit)="submit()">
  @if (!(policyList?.length === 1 && policyList[0]?.riskDescriptionList?.length === 1)) {
    <div class="row pad-bottom-16">
      <fieldset class="column twelve">
        <legend
          class="pad-vertical-10"
          dsContent
          [contentPath]="'policy.policiesListTitle'"
        ></legend>
        @for (policy of policyList; track policy; let isLastPolicy = $last) {
          <app-plchangerequest-policy
            [policy]="policy"
            [changeRequestForm]="policyChangeRequestForm"
            [policyControl]="policyChangeRequestForm.controls[policy.policyNumber]"
            [isLastPolicy]="isLastPolicy"
            [policySelectionValue]="policyList?.length === 1"
            (policyChanged)="updateSelectedPolicies($event)"
          >
          </app-plchangerequest-policy>
        }
      </fieldset>
    </div>
  }

  <!-- User Comments section -->
  <div class="row">
    <fieldset id="comments" class="column twelve">
      <legend
        class="pad-vertical-10"
        dsContent
        [contentPath]="'policy.policyCommentsAdditionalInfoText'"
      ></legend>

      <ds-form-control-container
        labelText="Details (max 850 characters)"
        [control]="commentInputCtrl"
      >
        <textarea
          maxlength="850"
          id="commentInput"
          class="fill"
          formControlName="commentInputCtrl"
          rows="5"
          data-cy="requestChangeDetailsInput"
        ></textarea>
        <ds-form-control-message [control]="commentInputCtrl"></ds-form-control-message>
      </ds-form-control-container>
      <span class="caption" dsContent [contentPath]="'policy.policyChangeDisclaimer'"></span>
    </fieldset>
  </div>

  <!-- Action Buttons -->
  <div class="row">
    <div class="column twelve callToAction">
      <span class="md-float-right">
        <a class="pad-horizontal-20" (click)="cancel()">Cancel</a>
        <button
          ds-button
          type="submit"
          class="-outline"
          aria-label="Submit"
          [disabled]="
            policyChangeRequestForm?.invalid ||
            !(roleService?.isAuthorized('reqpolicychangefrm_submit') | async) ||
            !enabledForm
          "
          data-cy="primaryButton"
        >
          Submit
        </button>
      </span>
    </div>
  </div>
</form>
